import { faQuestion } from '@fortawesome/free-solid-svg-icons';
import { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { Tag } from '.';
import { TAG_MAX_LENGTH, TAGS_MAX_COUNT } from '../utilities/tags';

type TagsAttributeProps = {
  // Request bodies say the attribute is optional and how updates work
  request?: boolean;
};

/**
 * The tags attribute of a list, item, index or identity
 *
 * Documented in one place to keep the wording consistent
 */
export function TagsAttribute({
  request = false,
}: TagsAttributeProps): ReactElement {
  return (
    <li>
      {request && (
        <Tag intent="warning" icon={faQuestion} show>
          optional
        </Tag>
      )}
      <code className="attribute">
        tags
        <span className="attribute-type">string[]</span>
      </code>
      <span className="attribute-description">
        <p>
          <Link to="/docs/tags">Tags</Link> for grouping related resources
          together, e.g. <code>["recipe-app", "production"]</code>.
        </p>
        {request && (
          <>
            <p>
              Tags are stored lowercase and can only contain letters, numbers,
              hyphens and underscores. There can be up to {TAGS_MAX_COUNT} tags,
              each up to {TAG_MAX_LENGTH} characters long.
            </p>
            <p>
              Setting tags replaces all of the existing tags, and an empty array
              removes them.
            </p>
          </>
        )}
      </span>
    </li>
  );
}
